<ng-container *ngIf="baseRoute && (ediNavigationService.getState$(baseRoute) | async) as state">
  <div *ngIf="state.isNavigationReady" class="d-flex flex-row justify-content-end">
    <button
      [disabled]="!state.isPreviousButtonActive"
      class="btn btn-outline-secondary"
      (click)="ediNavigationService.goToPrevious(baseRoute)"
    >
      <i class="fa-regular fa-arrow-left"></i>
    </button>
    <button
      [disabled]="!state.isNextButtonActive"
      class="btn btn-outline-secondary ml-2"
      (click)="ediNavigationService.goToNext(baseRoute)"
    >
      <i class="fa-regular fa-arrow-right"></i>
    </button>
  </div>
</ng-container>
